import React from 'react';

export function Panel({
  children,
  header,
  footer,
  toggleFilter
}: {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  toggleFilter
}) {

  return (
      <div className="ais-Panel">
        {header && <div className="ais-Panel-header" onClick={() => { toggleFilter(children.props.attribute) }}>{header}</div>}
        <div className="ais-Panel-body">{children}</div>
        {footer && <div className="ais-Panel-footer">{footer}</div>}
      </div>
  );
}
